<template>
  <div id="app">
    <!-- 桌面端/通用顶部导航 (吸顶) -->
    <header class="app-header">
      <div class="header-container">
        <!-- 左侧 Logo -->
        <div class="logo-area" @click="$router.push('/')">
          <img src="./assets/logo/logo1.png" alt="logo" class="logo-img" />
        </div>

        <!-- 桌面端菜单与操作 -->
        <div class="desktop-menu">
          <el-menu
            :default-active="activeIndex2"
            class="nav-menu"
            mode="horizontal"
            @select="handleSelect"
            background-color="transparent"
            text-color="var(--text-primary)"
            active-text-color="var(--primary-color)">
            
            <el-menu-item index="1">平台首页</el-menu-item>
            <el-menu-item index="2">产品展示</el-menu-item>
            <el-menu-item index="3">新闻资讯</el-menu-item>
            <el-menu-item index="4">关于我们</el-menu-item>
            <el-menu-item index="5">联系我们</el-menu-item>
            <el-menu-item index="6">留言反馈</el-menu-item>

            <!-- 用户/管理员动作组 -->
            <div class="user-action">
              <el-dropdown>
                <span class="el-dropdown-link user-dropdown">
                   <i class="el-icon-user-solid avatar-icon" style="font-size: 20px; color: #909399;"></i>
                   管理员<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="toAdmin()">后台管理</el-dropdown-item>
                  <el-dropdown-item>注销</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-menu>
        </div>

        <!-- 移动端汉堡包菜单按钮 (屏幕缩小至 900px 时显现) -->
        <div class="mobile-menu-btn" @click="drawerVisible = true">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </header>

    <!-- 侧边界面的联系悬浮栏（已在单独组件中） -->
    <SideNav></SideNav>

    <!-- 移动端专享抽屉导航 (Drawer) -->
    <el-drawer
      title="三辰服饰 - 菜单导航"
      :visible.sync="drawerVisible"
      direction="rtl"
      size="65%"
      :with-header="false">
      
      <div class="drawer-logo">
        <img src="./assets/logo/logo1.png" alt="logo" />
      </div>

      <el-menu
        :default-active="activeIndex2"
        class="mobile-nav-menu"
        @select="handleMobileSelect"
        active-text-color="var(--primary-color)">
        <el-menu-item index="1"><i class="el-icon-school"></i> 平台首页</el-menu-item>
        <el-menu-item index="2"><i class="el-icon-present"></i> 产品展示</el-menu-item>
        <el-menu-item index="3"><i class="el-icon-reading"></i> 新闻资讯</el-menu-item>
        <el-menu-item index="4"><i class="el-icon-postcard"></i> 关于我们</el-menu-item>
        <el-menu-item index="5"><i class="el-icon-phone"></i> 联系我们</el-menu-item>
        <el-menu-item index="6"><i class="el-icon-edit-outline"></i> 留言反馈</el-menu-item>
        <el-divider></el-divider>
        <el-menu-item @click.native="toAdmin()"><i class="el-icon-s-tools"></i> 进入后台管理</el-menu-item>
      </el-menu>
    </el-drawer>

    <!-- 主体路由内容视图 -->
    <main class="app-main">
       <router-view/>
    </main>

    <!-- 现代化黑曜石色企业全端大布局页脚 (Footer) -->
    <footer class="app-footer">
      <div class="footer-container">
        
        <!-- 卡片栏 1：关于企业 -->
        <div class="footer-col about-col">
          <h4 class="footer-title">泉州三辰服饰有限公司</h4>
          <p class="footer-desc">
            致力于品牌制服创意设计、生产与销售。引进现代企业制服新潮流，以匠心制作、高精准工艺及无忧退换货服务，始终为您打造尊享的企业专属形象体系。
          </p>
        </div>

        <!-- 卡片栏 2：直达快捷路由 -->
        <div class="footer-col link-col">
          <h4 class="footer-title">快捷指引</h4>
          <ul>
            <li @click="handleSelect('1')"><i class="el-icon-arrow-right"></i> 返回首页</li>
            <li @click="handleSelect('2')"><i class="el-icon-arrow-right"></i> 制服精选</li>
            <li @click="handleSelect('3')"><i class="el-icon-arrow-right"></i> 服饰百科</li>
            <li @click="handleSelect('4')"><i class="el-icon-arrow-right"></i> 关于三辰</li>
          </ul>
        </div>

        <!-- 卡片栏 3：详细联系通讯簿 -->
        <div class="footer-col contact-col">
          <h4 class="footer-title">即时联系</h4>
          <p><i class="el-icon-location"></i> 地址：福建省泉州市丰泽区尊湖22栋</p>
          <p><i class="el-icon-phone"></i> 热线：158 6034 7027</p>
          <p><i class="el-icon-user"></i> 经理：徐先生</p>
          <p><i class="el-icon-message"></i> 邮政编码：362000</p>
        </div>

        <!-- 卡片栏 4：微信互动展板 -->
        <div class="footer-col qr-col">
          <h4 class="footer-title">扫描添加微信</h4>
          <div class="footer-qr-card">
            <img src="./assets/homePub/wechat.jpg" alt="WeChat" class="footer-qrcode" />
          </div>
        </div>
      </div>
      
      <!-- 底栏版权说明 -->
      <div class="footer-bottom">
         <p>Copyright © 2024 泉州市三辰服饰有限公司 &nbsp;&nbsp; 盗版必究 &nbsp;&nbsp; 闽ICP备2021008xxx号</p>
      </div>
    </footer>
  </div>
</template>

<script>
import SideNav from '@/components/SideNav.vue'

export default {
  components: {
    SideNav
  },
  data() {
    return {
      activeIndex2: '1',
      drawerVisible: false
    };
  },
  watch: {
    // 监听路由改变时，主动反选导航高亮
    $route(to) {
      this.syncActiveIndex(to.path);
    }
  },
  methods: {
    syncActiveIndex(path) {
      if (path === '/' || path === '/home') this.activeIndex2 = '1'
      else if (path.startsWith('/product')) this.activeIndex2 = '2'
      else if (path.startsWith('/news') || path.startsWith('/article')) this.activeIndex2 = '3'
      else if (path.startsWith('/about')) this.activeIndex2 = '4'
      else if (path.startsWith('/contact')) this.activeIndex2 = '5'
      else if (path.startsWith('/reservation')) this.activeIndex2 = '6'
      else this.activeIndex2 = ''
    },
    handleSelect(key) {
      this.activeIndex2 = key;
      const routes = {
        '1': '/',
        '2': '/product',
        '3': '/article/1',
        '4': '/about',
        '5': '/contact',
        '6': '/reservation'
      };
      if (routes[key] && this.$route.path !== routes[key]) {
        this.$router.push(routes[key]).catch(err => {
          // 忽略 Vue Router 针对重复跳至同一路由报出的冗余警告
          if (err.name !== 'NavigationDuplicated') throw err;
        });
      }
    },
    handleMobileSelect(key) {
      // 移动端点选后自动回收关闭左侧抽屉
      this.drawerVisible = false;
      this.handleSelect(key);
    },
    toAdmin() {
      this.$router.push('/admin/login').catch(err => {});
    }
  },
  created() {
    this.syncActiveIndex(this.$route.path);
  }
}
</script>

<style>
/* === 全局 CSS 变量架构体系 === */
:root {
  /* 定义全局品牌主色调为主将蓝 */
  --primary-color: #2b579a; 
  --primary-light: #4c7ecb;
  
  /* 定义全局字体黑与辅色 */
  --text-primary: #303133;
  --text-regular: #606266;
  --text-secondary: #909399;
  
  /* 定义全局统一结构用色 */
  --bg-color: #f7f9fa;
  --border-color: #ebeef5;
  
  /* 定义底部 Footer 专用色组 */
  --footer-bg: #1b2636;
  --footer-text: #a3afb7;
}

/* 覆盖底层 HTML 全局配置，平滑滚屏和统配字体 */
body, html {
  margin: 0;
  padding: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  background-color: var(--bg-color);
  color: var(--text-primary);
  overflow-x: hidden;
  scroll-behavior: smooth;
}

/* ==== 纵向撑满拉伸机制 ==== */
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.app-main {
  flex: 1;
  width: 100%;
}

/* === 顶部全局 Header (Flex 抽屉式) === */
.app-header {
  background-color: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  position: sticky;
  top: 0;
  z-index: 999;
  backdrop-filter: blur(8px);
}
.header-container {
  max-width: 1200px;
  margin: 0 auto;
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

/* Logo 区块 */
.logo-area {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.logo-img {
  max-height: 40px;
  width: auto;
}

/* 桌面端长导航条 */
.desktop-menu {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.nav-menu.el-menu--horizontal {
  border-bottom: none !important;
  display: flex;
  align-items: center;
}
.nav-menu .el-menu-item {
  font-size: 15px;
  font-weight: 500;
  padding: 0 16px;
}
.user-action {
  margin-left: 30px;
  display: flex;
  align-items: center;
}
.user-dropdown {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 500;
  color: var(--text-regular);
}
.avatar-icon {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  margin-right: 6px;
}

/* 移动端汉堡包菜单召唤按钮 */
.mobile-menu-btn {
  display: none;
  font-size: 28px;
  color: var(--text-primary);
  cursor: pointer;
  padding: 10px;
}

/* 移动端左侧抽屉样式 */
.drawer-logo {
  padding: 30px 20px 20px;
  text-align: center;
  border-bottom: 1px solid var(--border-color);
}
.drawer-logo img {
  max-height: 45px;
}
.mobile-nav-menu {
  border-right: none;
}
.mobile-nav-menu .el-menu-item {
  font-size: 16px;
  font-weight: 500;
}

/* === 现代化页脚全端 Footer 矩阵 === */
.app-footer {
  background-color: var(--footer-bg);
  color: var(--footer-text);
  padding-top: 55px;
  margin-top: 40px;
}
.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 40px;
  padding-bottom: 45px;
}

/* 页脚标头 */
.footer-title {
  color: #fff;
  font-size: 17px;
  margin-bottom: 22px;
  font-weight: 600;
  border-left: 3px solid var(--primary-color);
  padding-left: 10px;
}

/* 专栏细节调优 */
.footer-desc {
  font-size: 15px;
  line-height: 1.9;
  color: #8c9ea9;
}

.link-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.link-col li {
  font-size: 15px;
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.3s;
  color: #8c9ea9;
}
.link-col li i {
  margin-right: 5px;
  font-size: 13px;
}
.link-col li:hover {
  color: var(--primary-light);
  transform: translateX(6px);
}

.contact-col p {
  font-size: 15px;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #8c9ea9;
}
.contact-col i {
  font-size: 16px;
  color: var(--primary-color);
}

.qr-col {
  text-align: left;
}
.footer-qr-card {
  display: inline-block;
  padding: 6px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0,0,0,0.2);
}
.footer-qrcode {
  width: 110px;
  height: 110px;
  display: block;
}

.footer-bottom {
  text-align: center;
  background-color: #121a24;
  padding: 24px 0;
  font-size: 14px;
  color: #687987;
}
.footer-bottom p {
  margin: 0;
}

/* === 多端大统一媒体查询 (响应式切屏) === */
@media screen and (max-width: 900px) {
  /* 干掉桌面菜单，显示抽屉按钮 */
  .desktop-menu {
    display: none;
  }
  .mobile-menu-btn {
    display: block;
  }
}

@media screen and (max-width: 600px) {
  /* 将 Footer 横向矩阵变为手机端纵列 */
  .footer-container {
    grid-template-columns: 1fr;
    text-align: left;
    gap: 30px;
  }
}
</style>